/**
 * Input — text input primitive.
 *
 * WHEN TO USE: single-line text fields (names, emails, search).
 * WHAT NOT TO DO: don't add padding/border overrides inline; use Field for label+error.
 */
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export default React.forwardRef<HTMLInputElement, InputProps>(
  function Input({ error, className = '', ...props }, ref) {
    return (
      <input
        ref={ref}
        className={[
          'w-full h-9 px-3 rounded-input bg-gray-800 border text-ui text-gray-100',
          'placeholder:text-gray-500',
          'transition-colors duration-fast',
          'focus:outline-none focus:ring-2 focus:ring-offset-0',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error
            ? 'border-danger-500 focus:ring-danger-500/30'
            : 'border-gray-700 focus:border-brand-500 focus:ring-brand-500/20',
          className,
        ].join(' ')}
        {...props}
      />
    );
  }
);
